import dayjs from 'dayjs';

const DataTable = (props) => {

  const isCodeView = props.viewFormat === 'code';
  const transactions = Array.isArray(props.transactions) ? props.transactions : [];
  const hasRows = transactions.length > 0;

  const codeTotal = transactions.reduce(
    (total, row) => (row.modval != null ? total + (row.sum * row.modval) : total + row.sum),
    0
  );

  const transactionTotal = transactions.reduce(
    (total, row) => (row.modval != null ? total + (row.modval * row.qteval) : total + row.qteval),
    0
  );

  return (
    <section className="chart-card historique-report-card">
      <div className="historique-report-header">
        <div>
          <h2 className="historique-section-title">
            {isCodeView ? 'Rapport par code' : 'Rapport par transaction'}
          </h2>
          <p className="historique-section-hint">
            {hasRows
              ? `${transactions.length} entrée${transactions.length > 1 ? 's' : ''}`
              : 'Aucune transaction pour cette semaine'}
          </p>
        </div>
        {hasRows && (
          <div className="historique-total-badge">
            <span className="historique-total-label">Total</span>
            <span className="historique-total-value">
              {(isCodeView ? codeTotal : transactionTotal).toFixed(2)} pts
            </span>
          </div>
        )}
      </div>

      {hasRows ? (
        <div className="historique-table-wrap">
          <table className="table historique-table" id="transac_list">
            <thead>
              {isCodeView ? (
                <tr>
                  <th scope="col">Code</th>
                  <th scope="col">Quantité</th>
                  <th scope="col">Valeur</th>
                  <th scope="col">Modificateur</th>
                  <th scope="col">Modif. val.</th>
                  <th scope="col">Total</th>
                </tr>
              ) : (
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Créée</th>
                  <th scope="col">Catégorie</th>
                  <th scope="col">Sous-catégorie</th>
                  <th scope="col">Description</th>
                  <th scope="col">Code</th>
                  <th scope="col">Notes</th>
                  <th scope="col">Valeur</th>
                  <th scope="col">Qté</th>
                  <th scope="col">Sous-total</th>
                  <th scope="col">Mod.</th>
                  <th scope="col">Mod. val.</th>
                  <th scope="col">Total</th>
                  <th scope="col"></th>
                </tr>
              )}
            </thead>
            <tbody>
              {isCodeView ? (
                transactions.map(transaction => (
                  <tr key={transaction.uid}>
                    <td>{transaction.code}</td>
                    <td>{transaction.qte}</td>
                    <td>{transaction.val}</td>
                    <td>{transaction.modificateur ?? '—'}</td>
                    <td>{transaction.modval ?? '—'}</td>
                    <td>{transaction.modval != null ? transaction.modval * transaction.sum : transaction.sum}</td>
                  </tr>
                ))
              ) : (
                transactions.map(transaction => (
                  <tr key={transaction.id}>
                    <td>{transaction.id}</td>
                    <td>{dayjs(transaction.created_at).format('YYYY-MM-DD')}</td>
                    <td>{transaction.cat}</td>
                    <td>{transaction.souscat}</td>
                    <td>{transaction.description}</td>
                    <td>{transaction.code}</td>
                    <td className="historique-notes-cell">{transaction.notes || '—'}</td>
                    <td>{transaction.val}</td>
                    <td>{transaction.qte}</td>
                    <td>{transaction.qteval}</td>
                    <td>{transaction.modificateur ?? '—'}</td>
                    <td>{transaction.modval ?? '—'}</td>
                    <td>{transaction.modval != null ? transaction.modval * transaction.qteval : transaction.qteval}</td>
                    <td>
                      <button
                        type="button"
                        name="delete_transac"
                        id={transaction.id}
                        className="btn btn-sm btn-outline-danger historique-delete-btn"
                        onClick={(e) => props.handleDelete(e)}
                        aria-label="Supprimer la transaction"
                      >
                        <i className="fas fa-trash-alt" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            {isCodeView && (
              <tfoot>
                <tr>
                  <td colSpan="5"><strong>Total</strong></td>
                  <td><strong>{codeTotal.toFixed(2)}</strong></td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      ) : (
        <div className="historique-empty-state">
          <i className="far fa-calendar-times historique-empty-icon" aria-hidden="true"></i>
          <p>Aucune transaction enregistrée pour la semaine sélectionnée.</p>
        </div>
      )}
    </section>
  );
};

export default DataTable;
